import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/download_logs'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    filterParams: {
      sdate: null,
      edate: null,
      component: null,
      is_used: null,
      id_users: null,
    },
    components: [
      { label: 'Ürünler', value: 'products' },
      { label: 'Hizmetler', value: 'services' },
      { label: 'Projeler', value: 'projects' },
    ],
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
    components(state) {
      return state.components
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('SET_DATA_LIST', [])
      axiosIns
        .get(ROOT_URL, { params })
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
